import Breadcrumb from '../../components/feature/Breadcrumb';
import Header from '../../components/feature/Header';
import Footer from '../../components/feature/Footer';
import { useLocation } from 'react-router-dom';

const PrivacyPolicyPage = () => {
  const location = useLocation();
  const isEnglish = location.pathname.startsWith('/en');

  const breadcrumbItems = isEnglish
    ? [
        { label: 'Home', path: '/en' },
        { label: 'Privacy Policy', path: '/en/privacy' }
      ]
    : [
        { label: 'ホーム', path: '/' },
        { label: 'プライバシーポリシー', path: '/privacy' }
      ];

  const TEXT = isEnglish ? {
    title: 'Privacy Policy',
    basicPolicy: 'Basic Policy',
    basicPolicyContent1: '"Sekisou NAG Note" (hereinafter "this site") is a technical note site for 3D printers operated by an individual. This site may collect minimal information to improve user convenience and site operation.',
    basicPolicyContent2: 'This site is intended for sharing personal research notes and experimental records, and does not use personal information for commercial purposes.',
    collectedInfo: 'Types of Information Collected',
    autoCollected: 'Automatically Collected Information',
    autoCollectedList: ['IP address', 'Access date and time', 'URLs of pages viewed', 'Browser type and version', 'Referrer (referring site)'],
    userProvided: 'Information Provided by Users',
    userProvidedList: ['Content entered in contact forms', 'Email address (when contacting)', 'Other information voluntarily provided by users'],
    googleAnalytics: 'About Google Analytics',
    googleAnalyticsContent1: 'This site uses or may use Google Analytics to understand site usage and improve content.',
    googleAnalyticsContent2: 'Google Analytics uses technologies such as cookies to collect and measure information about site browsing and usage (tracking), but does not include personally identifiable information.',
    googleAnalyticsContent3: 'Users can refuse this information collection by disabling cookies in their browser settings.',
    googleAdSense: 'About Google AdSense',
    googleAdSenseContent1: 'This site uses or may use Google AdSense for advertising distribution.',
    googleAdSenseContent2: 'Google AdSense uses technologies such as cookies to display ads based on users\' interests. This may result in ads being delivered based on users\' browsing history.',
    googleAdSenseContent3: 'Users can limit the display of interest-based ads by disabling cookies in their browser settings.',
    affiliateProgram: 'About Affiliate Programs',
    affiliateProgramContent1: 'This site participates in the following affiliate programs and may use affiliate links when introducing products or services.',
    affiliateList: ['Amazon Associates', 'ELEGOO affiliate via impact.com'],
    affiliateProgramContent2: 'If a product is purchased through an affiliate link, this site may receive compensation, but this does not change the price of the product.',
    affiliateProgramContent3: 'Affiliate links may use cookies to measure performance, and this information is managed according to the privacy policies of each affiliate provider.',
    contactInfo: 'Information Collected When Contacting',
    contactInfoContent1: 'Content submitted through the contact page (email address, name, message content, etc.) will be used only for responding to inquiries and necessary communications.',
    contactInfoContent2: 'Additionally, the contact form may collect IP addresses when submitted to prevent spam and unauthorized use. Collected IP addresses are used only for security purposes such as spam prevention and will not be used for any other purpose.',
    contactInfoContent3: 'This information is properly managed and will be deleted after an appropriate period following the completion of the response.',
    purposeOfUse: 'Purpose of Use of Personal Information',
    purposeList: ['Responding to inquiries', 'Operating the site and providing services', 'Analyzing and improving site usage', 'Compliance with laws and regulations'],
    thirdPartyDisclosure: 'Disclosure to Third Parties:',
    thirdPartyDisclosureContent: 'This site will not provide collected personal information to third parties except as required by law.',
    linkAndReprint: 'About Links and Reprints',
    linkTitle: 'About Links',
    linkContent: 'Links to this site (posting URLs) are free. No prior permission or notification is required.',
    reprintTitle: 'About Reprints',
    reprintContent1: 'Unauthorized reproduction of data, images, text, etc. from this site is prohibited.',
    reprintContent2: 'When quoting, please clearly indicate the source and do so within the minimum necessary scope. It is recommended to provide a link to this site as the source of the quote.',
    disclaimerRelation: 'Relationship with Disclaimer',
    disclaimerRelationContent: 'For responsibilities regarding the use of this site, please also refer to the separately defined ',
    disclaimerLink: 'disclaimer',
    policyChanges: 'Changes to Privacy Policy',
    policyChangesContent1: 'This privacy policy may be changed as necessary. In the event of changes, we will notify you by posting them on this page.',
    policyChangesContent2: 'Last updated: December 2025',
    contact: 'Contact',
    contactContent: 'For questions or comments regarding this privacy policy, please contact us through the ',
    contactLink: 'contact page'
  } : {
    title: 'プライバシーポリシー',
    basicPolicy: '基本方針',
    basicPolicyContent1: '「せきそう NAG ノート」（以下「当サイト」）は、個人が運営する3Dプリンターの技術ノートサイトです。当サイトでは、利用者の利便性向上とサイト運営のために、最小限の情報を取得することがあります。',
    basicPolicyContent2: '当サイトは個人的な研究ノート・実験記録の共有を目的としており、商業的な目的での個人情報の利用は行いません。',
    collectedInfo: '取得する情報の種類',
    autoCollected: '自動的に取得される情報',
    autoCollectedList: ['IPアドレス', 'アクセス日時', '閲覧されたページのURL', 'ブラウザの種類とバージョン', '参照元サイト（リファラー）'],
    userProvided: '利用者が提供する情報',
    userProvidedList: ['お問い合わせフォームに入力された内容', 'メールアドレス（お問い合わせ時）', 'その他、利用者が任意で提供する情報'],
    googleAnalytics: 'Google Analytics について',
    googleAnalyticsContent1: '当サイトでは、サイトの利用状況を把握し、コンテンツの改善を行うために、Google Analytics（グーグル アナリティクス）を利用している、または利用する場合があります。',
    googleAnalyticsContent2: 'Google Analytics では、Cookie（クッキー）等の技術を使用して、サイトの閲覧・利用状況に関する情報を収集・計測（トラッキング）することがありますが、個人を特定できる情報は含まれません。',
    googleAnalyticsContent3: '利用者は、ブラウザの設定で Cookie を無効化することにより、これらの情報収集を拒否することができます。',
    googleAdSense: 'Google AdSense について',
    googleAdSenseContent1: '当サイトでは、広告配信のために Google AdSense（グーグル アドセンス）を利用している、または利用する場合があります。',
    googleAdSenseContent2: 'Google AdSense では、Cookie 等の技術を使用して、利用者の興味関心に基づく広告を表示することがあります。これにより、利用者の閲覧履歴等に基づいた広告が配信される可能性があります。',
    googleAdSenseContent3: '利用者は、ブラウザの設定で Cookie を無効化することにより、興味関心に基づく広告の表示を制限することができます。',
    affiliateProgram: 'アフィリエイトプログラムについて',
    affiliateProgramContent1: '当サイトは、以下のアフィリエイトプログラムに参加しており、商品やサービスを紹介する際にアフィリエイトリンクを使用することがあります。',
    affiliateList: ['Amazonアソシエイト', 'impact.com 経由の ELEGOO アフィリエイト'],
    affiliateProgramContent2: 'アフィリエイトリンクを通じて商品が購入された場合、当サイトに報酬が発生することがありますが、これにより商品の価格が変わることはありません。',
    affiliateProgramContent3: 'アフィリエイトリンクでは、クッキー等を利用して成果を計測することがありますが、これらの情報は各アフィリエイト事業者のプライバシーポリシーに従って管理されます。',
    contactInfo: 'お問い合わせ時に取得する情報',
    contactInfoContent1: 'お問い合わせページから送信された内容（メールアドレス、お名前、メッセージ内容等）は、お問い合わせへの回答および必要な連絡のためだけに利用します。',
    contactInfoContent2: 'また、お問い合わせフォームでは、スパムや不正利用の防止を目的として、送信時に IP アドレスを取得することがあります。取得した IP アドレスは、スパム対策等のセキュリティ目的でのみ使用し、それ以外の目的で使用することはありません。',
    contactInfoContent3: 'これらの情報は適切に管理し、回答完了後は適切な期間経過後に削除いたします。',
    purposeOfUse: '個人情報の利用目的',
    purposeList: ['お問い合わせへの回答', 'サイトの運営およびサービスの提供', 'サイトの利用状況の分析と改善', '法令に基づく対応'],
    thirdPartyDisclosure: '個人情報の第三者提供について：',
    thirdPartyDisclosureContent: '当サイトでは、法令に基づく場合を除き、取得した個人情報を第三者に提供することはありません。',
    linkAndReprint: 'リンクと転載について',
    linkTitle: 'リンクについて',
    linkContent: '当サイトへのリンク（URL の貼り付け）は自由です。事前の許可や連絡は不要です。',
    reprintTitle: '転載について',
    reprintContent1: '当サイトのデータ、画像、文章等を無断で転載することは禁止します。',
    reprintContent2: '引用する場合は、出典を明記し、必要最小限の範囲内で行ってください。引用元として当サイトへのリンクを設置することを推奨します。',
    disclaimerRelation: '免責事項との関係',
    disclaimerRelationContent: '当サイトの利用に関する責任については、別途定める',
    disclaimerLink: '免責事項',
    policyChanges: 'プライバシーポリシーの変更',
    policyChangesContent1: '当プライバシーポリシーは、必要に応じて変更する場合があります。変更した場合は、当ページに掲載することによって通知いたします。',
    policyChangesContent2: '最終更新日：2025年12月',
    contact: 'お問い合わせ',
    contactContent: '当プライバシーポリシーに関するご質問やご意見は、',
    contactLink: 'お問い合わせページ'
  };

  return (
    <>
      <Header />
      <div className="min-h-screen bg-graphite mechanical-grid" data-lang={isEnglish ? 'en' : 'ja'}>
        <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
          <Breadcrumb items={breadcrumbItems} />
          
          <div className="space-y-8 mt-8">
            {/* ページタイトル */}
            <div className="text-center mt-8">
              <h1 className="text-4xl font-bold text-white font-['Exo'] mb-4">
                {TEXT.title}
              </h1>
              <div className="section-divider max-w-md mx-auto"></div>
            </div>

            <div className="metal-panel p-8 space-y-8">
              {/* イントロダクション */}
              <section>
                <h2 className="text-2xl font-semibold text-white font-['Exo'] mb-6">
                  {TEXT.basicPolicy}
                </h2>
                <div className="space-y-4 text-metal-light text-sm leading-relaxed">
                  <p>{TEXT.basicPolicyContent1}</p>
                  <p>{TEXT.basicPolicyContent2}</p>
                </div>
              </section>

              {/* 取得する情報の種類 */}
              <section>
                <h2 className="text-2xl font-semibold text-white font-['Exo'] mb-6">
                  {TEXT.collectedInfo}
                </h2>
                <div className="space-y-4 text-metal-light text-sm leading-relaxed">
                  <div className="bg-metal/30 p-4 border border-metal rounded">
                    <h3 className="text-white font-semibold mb-3">{TEXT.autoCollected}</h3>
                    <ul className="space-y-2">
                      {TEXT.autoCollectedList.map((item, idx) => (
                        <li key={idx}>• {item}</li>
                      ))}
                    </ul>
                  </div>
                  <div className="bg-metal/30 p-4 border border-metal rounded">
                    <h3 className="text-white font-semibold mb-3">{TEXT.userProvided}</h3>
                    <ul className="space-y-2">
                      {TEXT.userProvidedList.map((item, idx) => (
                        <li key={idx}>• {item}</li>
                      ))}
                    </ul>
                  </div>
                </div>
              </section>

              {/* Google Analytics について */}
              <section>
                <h2 className="text-2xl font-semibold text-white font-['Exo'] mb-6">
                  {TEXT.googleAnalytics}
                </h2>
                <div className="space-y-4 text-metal-light text-sm leading-relaxed">
                  <p>{TEXT.googleAnalyticsContent1}</p>
                  <p>{TEXT.googleAnalyticsContent2}</p>
                  <p>{TEXT.googleAnalyticsContent3}</p>
                </div>
              </section>

              {/* Google AdSense について */}
              <section>
                <h2 className="text-2xl font-semibold text-white font-['Exo'] mb-6">
                  {TEXT.googleAdSense}
                </h2>
                <div className="space-y-4 text-metal-light text-sm leading-relaxed">
                  <p>{TEXT.googleAdSenseContent1}</p>
                  <p>{TEXT.googleAdSenseContent2}</p>
                  <p>{TEXT.googleAdSenseContent3}</p>
                </div>
              </section>

              {/* アフィリエイトリンクについて */}
              <section>
                <h2 className="text-2xl font-semibold text-white font-['Exo'] mb-6">
                  {TEXT.affiliateProgram}
                </h2>
                <div className="space-y-4 text-metal-light text-sm leading-relaxed">
                  <p>{TEXT.affiliateProgramContent1}</p>
                  <div className="bg-metal/30 p-4 border border-metal rounded">
                    <ul className="space-y-2">
                      {TEXT.affiliateList.map((item, idx) => (
                        <li key={idx}>• {item}</li>
                      ))}
                    </ul>
                  </div>
                  <p>{TEXT.affiliateProgramContent2}</p>
                  <p>{TEXT.affiliateProgramContent3}</p>
                </div>
              </section>

              {/* お問い合わせ時の情報 */}
              <section>
                <h2 className="text-2xl font-semibold text-white font-['Exo'] mb-6">
                  {TEXT.contactInfo}
                </h2>
                <div className="space-y-4 text-metal-light text-sm leading-relaxed">
                  <p>{TEXT.contactInfoContent1}</p>
                  <p>{TEXT.contactInfoContent2}</p>
                  <p>{TEXT.contactInfoContent3}</p>
                </div>
              </section>

              {/* 個人情報の利用目的 */}
              <section>
                <h2 className="text-2xl font-semibold text-white font-['Exo'] mb-6">
                  {TEXT.purposeOfUse}
                </h2>
                <div className="space-y-4 text-metal-light text-sm leading-relaxed">
                  <div className="bg-metal/30 p-4 border border-metal rounded">
                    <ul className="space-y-2">
                      {TEXT.purposeList.map((item, idx) => (
                        <li key={idx}>• {item}</li>
                      ))}
                    </ul>
                  </div>
                  <p>
                    <strong className="text-white">{TEXT.thirdPartyDisclosure}</strong>
                    {TEXT.thirdPartyDisclosureContent}
                  </p>
                </div>
              </section>

              {/* リンクと転載について */}
              <section>
                <h2 className="text-2xl font-semibold text-white font-['Exo'] mb-6">
                  {TEXT.linkAndReprint}
                </h2>
                <div className="space-y-4 text-metal-light text-sm leading-relaxed">
                  <div className="bg-metal/30 p-4 border border-metal rounded">
                    <h3 className="text-white font-semibold mb-3">{TEXT.linkTitle}</h3>
                    <p>{TEXT.linkContent}</p>
                  </div>
                  <div className="bg-metal/30 p-4 border border-metal rounded">
                    <h3 className="text-white font-semibold mb-3">{TEXT.reprintTitle}</h3>
                    <p className="mb-3">{TEXT.reprintContent1}</p>
                    <p>{TEXT.reprintContent2}</p>
                  </div>
                </div>
              </section>

              {/* 免責事項との関係 */}
              <section>
                <h2 className="text-2xl font-semibold text-white font-['Exo'] mb-6">
                  {TEXT.disclaimerRelation}
                </h2>
                <div className="space-y-4 text-metal-light text-sm leading-relaxed">
                  <p>
                    {TEXT.disclaimerRelationContent}
                    <a href={isEnglish ? '/en/disclaimer' : '/disclaimer'} className="text-accent hover:underline">{TEXT.disclaimerLink}</a>
                    {isEnglish ? '.' : 'もあわせてご確認ください。'}
                  </p>
                </div>
              </section>

              {/* ポリシーの変更 */}
              <section>
                <h2 className="text-2xl font-semibold text-white font-['Exo'] mb-6">
                  {TEXT.policyChanges}
                </h2>
                <div className="space-y-4 text-metal-light text-sm leading-relaxed">
                  <p>{TEXT.policyChangesContent1}</p>
                  <p className="text-xs text-metal-light">{TEXT.policyChangesContent2}</p>
                </div>
              </section>

              {/* 連絡先 */}
              <section>
                <h2 className="text-2xl font-semibold text-white font-['Exo'] mb-6">
                  {TEXT.contact}
                </h2>
                <div className="space-y-4 text-metal-light text-sm leading-relaxed">
                  <p>
                    {TEXT.contactContent}
                    <a href={isEnglish ? '/en/contact' : '/contact'} className="text-accent hover:underline">{TEXT.contactLink}</a>
                    {isEnglish ? '.' : 'からご連絡ください。'}
                  </p>
                </div>
              </section>
            </div>
          </div>
        </div>
      </div>
      <Footer />
    </>
  );
};

export default PrivacyPolicyPage;
